import React from 'react';

import { Teacher, Video } from '@edx/graphql/generated';
import { useAppConfigStateContext } from '@edx/contexts/app-config';
import { TestimonialProps } from '@edx/components/testimonials-carousel';

import { WelcomePage } from '@edx/pages/welcome';

export { getStaticProps } from '@edx/pages/welcome';

const bgImage = {
  large: '/img/home/home_heading-l.jpg',
  medium: '/img/home/home_heading-m.jpg',
  small: '/img/home/home_heading-s.jpg',
};

type Props = {
  latestVideos: Video[];
  teacher: Teacher;
  testimonials: TestimonialProps[];
};

export const exampleLessons = [
  {
    label: 'Principiante',
    embedId: 333971804,
    thumbnail: '/img/landings/empieza-ahora/beginner-example-lesson.jpg',
  },
  {
    label: 'Intermedio',
    embedId: 333962825,
    thumbnail: '/img/landings/empieza-ahora/intermediate-example-lesson.jpg',
  },
  {
    label: 'Avanzado',
    embedId: 439511344,
    thumbnail: '/img/landings/empieza-ahora/advanced-example-lesson.jpg',
  },
];

const Welcome: React.FC<Props> = ({ latestVideos, teacher, testimonials }) => {
  const { projectName, projectShortName } = useAppConfigStateContext();

  return (
    <WelcomePage
      bgImage={bgImage}
      latestVideos={latestVideos}
      projectName={projectName}
      projectShortName={projectShortName}
      teacher={teacher}
      testimonials={testimonials}
      exampleLessons={exampleLessons}
    />
  );
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Welcome.navBar = { position: 'absolute', variant: 'transparent' };

export default Welcome;
